// src/components/SalidaEntradaPatrones/DetalleMovimiento.jsx
import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Table,
  Modal,
  Form,
  Spinner,
  Alert,
  Timeline
} from 'react-bootstrap';
import {
  FaArrowLeft,
  FaCheckCircle,
  FaClock,
  FaPlus,
  FaLock,
  FaUser,
  FaCalendar,
  FaExclamationTriangle
} from 'react-icons/fa';
import {
  getMovimientosPorGrupo,
  agregarOtMovimiento,
  completarOtMovimiento,
  cerrarMovimiento,
  createMovimientoBulk
} from '../../api/movimientosService';
import { getDataList } from '../../api/common';
import { Alertassw } from '../Alertas/Alertassw';
import StatusBadge from './StatusBadge';
import OtSelector from './OtSelector';
import MovimientoCard from './MovimientoCard';
import moment from 'moment';
import 'moment/locale/es';
import capitalizeText from '../../utils/capitalizeText';

moment.locale('es');

/**
 * Vista de detalle de un grupo de movimientos (misma salida)
 */
const DetalleMovimiento = ({ groupConsecutive, movimientoId, onBack, onRefresh }) => {

    console.log('DetalleMovimiento props:', { groupConsecutive, movimientoId });
  const [movimientos, setMovimientos] = useState([]);
  console.log(movimientos)
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);

  console.log(movimientos)
  // Modales
  const [showAgregarOtModal, setShowAgregarOtModal] = useState(false);
  const [showCompletarOtModal, setShowCompletarOtModal] = useState(false);
  const [showCerrarModal, setShowCerrarModal] = useState(false);
  const [showCerrarTodoModal, setShowCerrarTodoModal] = useState(false);

  // Agregar Patrón al grupo
  const [showAgregarPatronModal, setShowAgregarPatronModal] = useState(false);
  const [patronesDisponibles, setPatronesDisponibles] = useState([]);
  const [loadingPatrones, setLoadingPatrones] = useState(false);
  const [patronesSeleccionados, setPatronesSeleccionados] = useState([]);
  const [notasAgregarPatron, setNotasAgregarPatron] = useState('');
  const [filtroPatrones, setFiltroPatrones] = useState({ inventario: '', marca: '', modelo: '' });

  // Estados temporales
  const [movimientoSeleccionado, setMovimientoSeleccionado] = useState(null);
  const [otSeleccionada, setOtSeleccionada] = useState(null);
  const [otIdNueva, setOtIdNueva] = useState('');
  const [notasAgregar, setNotasAgregar] = useState('');
  const [notasCompletar, setNotasCompletar] = useState('');
  const [notasCerrar, setNotasCerrar] = useState('');
  const [notasCerrarTodo, setNotasCerrarTodo] = useState('');
  const [forzarCierre, setForzarCierre] = useState(true);
  const [procesando, setProcesando] = useState(false);

  console.log('ot seleccionada:', otSeleccionada);
  useEffect(() => {
    cargarMovimientos();
  }, [refreshKey, groupConsecutive, movimientoId]);

  const cargarMovimientos = async () => {
    setLoading(true);
    try {
      const response = await getMovimientosPorGrupo(groupConsecutive);
      setMovimientos(response.data || []);
    } catch (error) {
      console.error('error al cargar movimientos:', error);
      Alertassw('error', 'No se pudieron cargar los movimientos', 'error');
    } finally {
      setLoading(false);
    }
  };

  console.log('movimiento seleccionado:', movimientoSeleccionado);
  const handleAgregarOt = (movimiento) => {
    setMovimientoSeleccionado(movimiento);
    setOtIdNueva('');
    setNotasAgregar('');
    setShowAgregarOtModal(true);
  };

  const confirmarAgregarOt = async () => {
    if (!otIdNueva) {
      Alertassw('error', 'Debes seleccionar una OT', 'warning');
      return;
    }

    setProcesando(true);
    try {
      await agregarOtMovimiento(movimientoSeleccionado._id, {
        otId: otIdNueva,
        notes: notasAgregar.trim() || undefined
      });

      Alertassw('success', 'La orden de trabajo se agregó correctamente al movimiento', 'success');
      setShowAgregarOtModal(false);
      setRefreshKey(prev => prev + 1);
      if (onRefresh) onRefresh();
    } catch (error) {
      console.error('error al agregar OT:', error);
      Alertassw('error', error.response?.data?.message || 'No se pudo agregar la OT', 'error');
    } finally {
      setProcesando(false);
    }
  };

  const handleCompletarOt = (movimiento) => {
    // Buscar OTs pendientes
    const otsPendientes = movimiento?.otAssignments?.filter(
      ot => ot.status === 'pending' || ot.status === 'in-progress'
    ) || [];

    if (otsPendientes.length === 0) {
      Alertassw('info_input','Sin OTs pendientes', 'No hay órdenes de trabajo pendientes en este movimiento', 'info');
      return;
    }

    setMovimientoSeleccionado(movimiento);
    setOtSeleccionada(otsPendientes[0]); // Por defecto, la primera pendiente
    setNotasCompletar('');
    setShowCompletarOtModal(true);
  };

  const confirmarCompletarOt = async () => {
    if (!otSeleccionada) {
      Alertassw('error', 'No hay OT seleccionada', 'error');
      return;
    }

    setProcesando(true);
    try {
      await completarOtMovimiento(
        movimientoSeleccionado._id,
        otSeleccionada.ot.otId || otSeleccionada.ot.otId,
        { notes: notasCompletar.trim() || undefined }
      );

      Alertassw('success', 'La orden de trabajo se marcó como completada', 'success');
      setShowCompletarOtModal(false);
      setRefreshKey(prev => prev + 1);
      if (onRefresh) onRefresh();
    } catch (error) {
      console.error('error al completar OT:', error);
      Alertassw('error', error.response?.data?.message || 'No se pudo completar la OT', 'error');
    } finally {
      setProcesando(false);
    }
  };

  const handleCerrarMovimiento = (movimiento) => {
    setMovimientoSeleccionado(movimiento);
    setNotasCerrar('');
    setForzarCierre(false);
    setShowCerrarModal(true);
  };

  const confirmarCerrarMovimiento = async () => {
    setProcesando(true);
    try {
      await cerrarMovimiento(movimientoSeleccionado._id, {
        notes: notasCerrar.trim() || undefined,
        forceClose: forzarCierre
      });

      Alertassw('success','Movimiento Cerrado', 'El equipo ha sido devuelto exitosamente', 'success');
      setShowCerrarModal(false);
      setRefreshKey(prev => prev + 1);
      if (onRefresh) onRefresh();
    } catch (error) {
      console.error('error al cerrar movimiento:', error);
      const errorMsg = error.response?.data?.message || 'No se pudo cerrar el movimiento';
      
      if (errorMsg.includes('pendientes')) {
        Alertassw(
          'error',
          'Hay órdenes de trabajo pendientes. Marca la opción "Forzar cierre" si deseas cerrar de todas formas.',
          'warning'
        );
      } else {
        Alertassw('error', errorMsg, 'error');
      }
    } finally {
      setProcesando(false);
    }
  };

  const handleCerrarTodoMovimiento = () => {
    setNotasCerrarTodo('');
    setShowCerrarTodoModal(true);
  };

  const confirmarCerrarTodoMovimiento = async () => {
    setProcesando(true);
    try {
      // Cerrar todos los movimientos del grupo
      const promesas = movimientos
        .filter(mov => mov.status === 'open')
        .map(mov => 
          cerrarMovimiento(mov._id, {
            notes: notasCerrarTodo.trim() || undefined,
            forceClose: true // Forzar cierre para cerrar todo el grupo
          })
        );

      await Promise.all(promesas);

      Alertassw(
        'success',
        'Movimiento Completo Cerrado',
        `${promesas.length} equipo(s) devuelto(s) exitosamente`,
        'success'
      );
      
      setShowCerrarTodoModal(false);
      setRefreshKey(prev => prev + 1);
      if (onRefresh) onRefresh();
      
      // Volver al dashboard después de cerrar todo
      setTimeout(() => {
        if (onBack) onBack();
      }, 1500);
    } catch (error) {
      console.error('error al cerrar todo el movimiento:', error);
      Alertassw(
        'error',
        error.response?.data?.message || 'No se pudo cerrar el movimiento completo',
        'error'
      );
    } finally {
      setProcesando(false);
    }
  };

  // Verificar si hay OTs pendientes en el movimiento
  const hayOtsPendientes = (movimiento) => {
    return movimiento?.otAssignments?.some(
      ot => ot.status === 'pending' || ot.status === 'in-progress'
    );
  };

  const handleAgregarPatron = async () => {
    setPatronesSeleccionados([]);
    setNotasAgregarPatron('');
    setFiltroPatrones({ inventario: '', marca: '', modelo: '' });
    setLoadingPatrones(true);
    setShowAgregarPatronModal(true);
    try {
      const resp = await getDataList('Patrones', { tipoEquipo: 'Patrón' });
      setPatronesDisponibles(resp.data.data || []);
    } catch (e) {
      console.error('Error cargando patrones:', e);
      setPatronesDisponibles([]);
    } finally {
      setLoadingPatrones(false);
    }
  };

  const confirmarAgregarPatron = async () => {
    if (patronesSeleccionados.length === 0) {
      Alertassw('warning', 'Selecciona al menos un patrón', '');
      return;
    }
    const primerMov = movimientos.find(m => m.status === 'open') || movimientos[0];
    if (!primerMov) return;

    // Reusar otAssignments del grupo
    const otIds = (primerMov.otAssignments || []).map(a => ({
      otId: a.ot?.otId,
      cliente: a.ot?.cliente || '',
      numeroOt: a.ot?.numeroOt || '',
      ciudad: a.ot?.ciudad || ''
    })).filter(o => o.otId);

    setProcesando(true);
    try {
      await createMovimientoBulk({
        patronIds: patronesSeleccionados,
        otIds,
        responsibleUserId: primerMov.responsibleUserId?._id || primerMov.responsibleUserId,
        groupConsecutive,
        dueDate: primerMov.dueDate,
        notes: notasAgregarPatron.trim() || undefined
      });
      Alertassw('success', `${patronesSeleccionados.length} patrón(es) agregado(s) al grupo ${groupConsecutive}`, '');
      setShowAgregarPatronModal(false);
      setRefreshKey(prev => prev + 1);
      if (onRefresh) onRefresh();
    } catch (err) {
      Alertassw('error', err.response?.data?.message || 'No se pudo agregar el patrón', '');
    } finally {
      setProcesando(false);
    }
  };

    // Calcular tiempo transcurrido
    const getTiempoFuera = (movimiento) => {
      if (!movimiento?.startedAt) return 'N/A';
      const now = moment();
      const start = moment(movimiento.startedAt);
      const duration = moment.duration(now.diff(start));
  
      console.log('movimiento:', movimiento);
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
  
      if (days > 0) {
        return `${days}d ${hours}h`;
      } else if (hours > 0) {
        return `${hours}h ${minutes}m`;
      } else {
        return `${minutes}m`;
      }
    };

  if (loading) {
    return (
      <div className="text-center py-4"><Spinner animation="border" variant="primary" /><p className="mt-3">Cargando detalles...</p></div>
    );
  }

  if (movimientos.length === 0) {
    return (
      <div className="p-4">
        <Alert variant="warning">No se encontraron movimientos para este grupo</Alert>
        <Button variant="outline-secondary" onClick={onBack}><FaArrowLeft className="me-2" />Volver</Button>
      </div>
    );
  }

  // si todos estan cerrado el estado es cerrado, si alguno abierto es abierto 
  const estadoGrupo = movimientos.every(mov => mov.status === 'closed') ? 'closed' : 'open';
  const responsable = movimientos[0].responsibleUserId;

  return (
    <>
    <Container fluid className="py-4">
      {/* Header */}
      <Row className="mb-4">
        <Col>
          <div className="d-flex align-items-center gap-3 mb-3">
            <Button variant="outline-secondary" onClick={onBack}>
              <FaArrowLeft />
            </Button>
            <div className="flex-grow-1">
              <h2 className="text-primary fw-bold mb-1">
                Movimiento: {groupConsecutive}
              </h2>
              <p className="text-muted mb-0">
                Gestión de salida y devolución de equipos patrón
              </p>
            </div>
            <StatusBadge type="movimiento" status={estadoGrupo} size="lg" />
            {estadoGrupo === 'open' && (
              <Button 
                variant="danger" 
                onClick={handleCerrarTodoMovimiento}
                className="d-flex align-items-center gap-2"
              >
                <FaLock />
                Cerrar Todo el Movimiento
              </Button>
            )}
          </div>
        </Col>
      </Row>

      {/* Información general del grupo */}
      <Card className="shadow-sm mb-4 w-100">
        <Card.Body className='w-100'>
          <Row>
            <Col md={4}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FaCalendar className="text-muted" />
                <div>
                  <small className="text-muted d-block">Fecha de Salida</small>
                  <strong>{moment(movimientos[0].startedAt).format('DD/MM/YYYY HH:mm')}</strong>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FaUser className="text-muted" />
                <div>
                  <small className="text-muted d-block">Responsable</small>
                  <strong>
                    {responsable?.nombre} {responsable?.apellido}
                  </strong>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FaClock className="text-muted" />
                <div>
                  <small className="text-muted d-block">Total Patrones</small>
                  <strong>{movimientos.length}</strong>
                </div>
              </div>
            </Col>
          </Row>

          {estadoGrupo === 'closed' && movimientos[0].closedAt && (
            <Row className="mt-3">
              <Col>
                <Alert variant="success" className="mb-0">
                  <FaCheckCircle className="me-2" />
                  Movimiento cerrado el {moment(movimientos[0].closedAt).format('DD/MM/YYYY HH:mm')}
                </Alert>
              </Col>
            </Row>
          )}

          {movimientos[0].notes && (
            <Row className="mt-3">
              <Col>
                <small className="text-muted d-block mb-1">Notas iniciales:</small>
                <p className="mb-0">{movimientos[0].notes}</p>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      {/* Patrones involucrados (Grid de tarjetas) */}
      <Card className="shadow-sm mb-4 w-100">
        <Card.Header className='w-100 d-flex justify-content-between align-items-center'>
          <h5 className="mb-0">Equipos en este Movimiento</h5>
          {estadoGrupo === 'open' && (
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={handleAgregarPatron}
            >
              <i className="bi bi-plus-circle me-1"/>Agregar Patrón
            </button>
          )}
        </Card.Header>
        <Card.Body className='w-100'>
          <Table>
            <thead className="table-light">
              <tr>
                <th>Inventario</th>
                <th>Patrón</th>
                {/* definir el ancho de la columna en porcentaje de ordenes para que no se vea tan apretada */}
                <th
                  style={{ width: '20%' }}
                
                >Ordenes</th>
                <th>Observación</th>
                <th><FaClock /> Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {movimientos.map((movimiento,index) => (
                <tr key={movimiento._id}>
                  <td>{movimiento.patronId?.inventario.toUpperCase()}</td>
                  <td>
                    <div className="mb-2">
                      <h6 className="text-truncate">{capitalizeText(movimiento.patronId?.item) || 'Sin descripción'}</h6>
                      <small className="text-muted">
                        {movimiento.patronId?.marca} {movimiento.patronId?.modelo}
                        {movimiento.patronId?.serie && ` | S/N: ${movimiento.patronId.serie}`}
                      </small>
                    </div>
                  </td>
                  <td>
                  {movimiento?.otAssignments && movimiento?.otAssignments.length > 0 && (
                    <div className="d-flex flex-column gap-1">
                      {movimiento.otAssignments.slice(0, 3).map((otAssignment, idx) => (
                        <div
                          key={idx}
                          className="d-flex justify-content-between align-items-center"
                        >
                          {otAssignment.ot ? 
                            <div className="cliente text-truncate" style={{ maxWidth: '85%' }}>
                              {otAssignment.ot?.numeroOt || 'N/A'} - {(capitalizeText(otAssignment.ot.cliente) || 'Sin descripción').substring(0, 15)}{(capitalizeText(otAssignment.ot.cliente) || 'Sin descripción').length > 15 ? '...' : ''}
                            </div> : <small className="text-muted">Sin descripción</small>
                          }
                        </div>
                      ))}
                    </div>
                  )}

                  </td>
                  <td>
                    {movimiento?.notes && (
                      <div className="mb-2">
                        <small className="text-muted fst-italic">
                          "{movimiento.notes.substring(0, 60)}
                          {movimiento.notes.length > 60 ? '...' : ''}"
                        </small>
                      </div>
                    )}
                  </td>
                  <td>
                    <div className="mb-2">
                      <StatusBadge
                        type="movimiento"
                        status={movimiento?.status || 'open'}
                        size="sm"
                      />

                        {movimiento?.status === 'open' && (
                          <div className="d-flex align-items-center gap-2 mb-2 text-muted">
                            <small>Hace {getTiempoFuera(movimiento)}</small>
                          </div>
                        )}
                     </div>
                  </td>
                  <td>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-2"
                      disabled = {movimiento?.status === 'closed'}
                      onClick={() => handleAgregarOt(movimiento)}
                      title='Adicionar OT a este equipo'
                    >
                      + OT
                    </Button>

                    {/* colocar tooltip en el boton de completar OT, si no hay OTs pendientes decir "No hay OTs pendientes" */}
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="me-2"
                      disabled = {movimiento?.status === 'closed'}
                      onClick={() => handleCerrarMovimiento(movimiento)}
                      title='Ingresar Equipo a Laboratorio para todas las Ots Asignadas'
                    >
                      Ingresar

                    </Button>
                  </td>
                </tr>
              ))}

            </tbody>

          </Table>
        </Card.Body>
      </Card>
      

      {/*<Row className="g-3 mb-4">
        {movimientos.map((movimiento) => (
          <Col key={movimiento._id} md={6} lg={4}>
            <MovimientoCard
              movimiento={movimiento}
              showActions={estadoGrupo === 'open'}
              onAgregarOt={handleAgregarOt}
              onCompletarOt={handleCompletarOt}
              onCerrarMovimiento={handleCerrarMovimiento}
            />
          </Col>
        ))}
      </Row>*/}

      {/* Timeline de actividad */}
      <Card className="shadow-sm mb-4 w-100">
        <Card.Header className="bg-light w-100">
          <h5 className="mb-0">Timeline de Actividad</h5>
        </Card.Header>
        <Card.Body className="w-100">
          <Table hover size="sm">
            <thead className="table-light">
              <tr>
                <th>Fecha/Hora</th>
                <th>Evento</th>
                <th>Detalles</th>
              </tr>
            </thead>
            <tbody>
              {movimientos.map((movimiento) => {
                const eventos = [];

                // Evento de creación
                eventos.push({
                  fecha: movimiento.startedAt,
                  tipo: 'Creación',
                  detalle: `Patrón ${movimiento.patronId?.inventario} registrado para salida`
                });

                // Eventos de OTs
                movimiento?.otAssignments?.forEach((ot) => {
                  if (ot.assignedAt) {
                    eventos.push({
                      fecha: ot.assignedAt,
                      tipo: 'OT Asignada',
                      detalle: `OT ${ot.ot.numeroOt || 'N/A'} asignada`
                    });
                  }
                  if (ot.completedAt) {
                    eventos.push({
                      fecha: ot.completedAt,
                      tipo: 'OT Completada',
                      detalle: `OT ${ot.ot?.numeroOt || 'N/A'} completada`
                    });
                  }
                });

                // Evento de cierre
                if (movimiento.closedAt) {
                  eventos.push({
                    fecha: movimiento.closedAt,
                    tipo: 'Cierre',
                    detalle: `Patrón ${movimiento.patronId?.inventario} devuelto`
                  });
                }

                return eventos;
              })
                .flat()
                .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
                .map((evento, idx) => (
                  <tr key={idx}>
                    <td>
                      <small>{moment(evento.fecha).format('DD/MM/YYYY HH:mm')}</small>
                    </td>
                    <td>
                      <Badge bg="secondary">{evento.tipo}</Badge>
                    </td>
                    <td>
                      <small>{evento.detalle}</small>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* Modal Agregar OT */}
      <Modal
        show={showAgregarOtModal}
        onHide={() => setShowAgregarOtModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaPlus className="me-2" />
            Agregar Orden de Trabajo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="w-100">
          <Form.Group className="mb-3">
            <Form.Label>Selecciona la OT *</Form.Label>
            <OtSelector
              value={otIdNueva ? [otIdNueva] : []}
              onChange={(value) => setOtIdNueva(value[0] || '')}
              multiple={false}
              disabled={procesando}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Notas (opcional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Observaciones adicionales..."
              value={notasAgregar}
              onChange={(e) => setNotasAgregar(e.target.value)}
              disabled={procesando}
              maxLength={300}
            />
            <Form.Text>{notasAgregar.length}/300</Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAgregarOtModal(false)}
            disabled={procesando}
          >
            Cancelar
          </Button>
          <Button variant="primary" onClick={confirmarAgregarOt} disabled={procesando}>
            {procesando ? <Spinner animation="border" size="sm" /> : 'Agregar OT'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Completar OT */}
      <Modal
        show={showCompletarOtModal}
        onHide={() => setShowCompletarOtModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaCheckCircle className="me-2 text-success" />
            Completar Orden de Trabajo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="w-100">
          {movimientoSeleccionado?.otAssignments
            ?.filter(ot => ot.status === 'pending' || ot.status === 'in-progress')
            .map((ot, idx) => (
              <Form.Check
                key={idx}
                type="radio"
                label={`${ot.ot?.numeroOt || 'N/A'} - ${ot.ot?.cliente || 'Sin cliente'}`}
                name="otCompletar"
                checked={otSeleccionada?._id === ot._id}
                onChange={() => setOtSeleccionada(ot)}
                className="mb-2"
                disabled={procesando}
              />
            ))}

          <Form.Group className="mt-3">
            <Form.Label>Notas de completación (opcional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Ej: Calibración completada exitosamente, equipo en buen estado..."
              value={notasCompletar}
              onChange={(e) => setNotasCompletar(e.target.value)}
              disabled={procesando}
              maxLength={300}
            />
            <Form.Text>{notasCompletar.length}/300</Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowCompletarOtModal(false)}
            disabled={procesando}
          >
            Cancelar
          </Button>
          <Button variant="success" onClick={confirmarCompletarOt} disabled={procesando}>
            {procesando ? <Spinner animation="border" size="sm" /> : 'Marcar como Completada'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Cerrar Movimiento */}
      <Modal
        show={showCerrarModal}
        onHide={() => setShowCerrarModal(false)}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaLock className="me-2 text-danger" />
            Cerrar Movimiento (Devolver Equipo)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="w-100">
          {hayOtsPendientes(movimientoSeleccionado) && (
            <Alert variant="warning">
              <FaExclamationTriangle className="me-2" />
              <strong>Atención:</strong> Esta acción cierra la salida para todas las Ots asigandas.
            </Alert>
          )}

          <p>
            <strong>Patrón:</strong> {movimientoSeleccionado?.patronId?.inventario.toUpperCase()} -{' '}
            {capitalizeText(movimientoSeleccionado?.patronId?.item)}
          </p>

          <Form.Group className="mb-3">
            <Form.Label>Notas de cierre (opcional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Ej: Equipo devuelto en buen estado, sin novedades..."
              value={notasCerrar}
              onChange={(e) => setNotasCerrar(e.target.value)}
              disabled={procesando}
              maxLength={500}
            />
            <Form.Text>{notasCerrar.length}/500</Form.Text>
          </Form.Group>

         {/* {hayOtsPendientes(movimientoSeleccionado) && (
            <Form.Check
              type="checkbox"
              label="Forzar cierre (cerrar aunque haya OTs pendientes)"
              checked={forzarCierre}
              onChange={(e) => setForzarCierre(e.target.checked)}
              disabled={procesando}
              className="text-danger"
            />
          )}*/}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowCerrarModal(false)}
            disabled={procesando}
          >
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmarCerrarMovimiento} disabled={procesando}>
            {procesando ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <>
                <FaLock className="me-2" />
                Cerrar Movimiento
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Cerrar TODO el Movimiento (Grupo Completo) */}
      <Modal
        show={showCerrarTodoModal}
        onHide={() => setShowCerrarTodoModal(false)}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaLock className="me-2 text-danger" />
            Cerrar TODO el Movimiento
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="w-100">
          <Alert variant="danger">
            <FaExclamationTriangle className="me-2" />
            <strong>¡Atención!</strong> Esta acción cerrará <strong>TODOS</strong> los equipos de este movimiento ({movimientos.filter(m => m.status === 'open').length} equipo(s) abierto(s)).
            Esta acción no se puede deshacer.
          </Alert>

          <div className="mb-3">
            <strong>Equipos que se cerrarán:</strong>
            <ul className="mt-2">
              {movimientos
                .filter(mov => mov.status === 'open')
                .map(mov => (
                  <li key={mov._id}>
                    {mov.patronId?.inventario.toUpperCase()} - {capitalizeText(mov.patronId?.item)} - {mov.patronId?.marca}/{mov.patronId?.modelo}
                  </li>
                ))}
            </ul>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Observaciones de cierre *</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Ej: Todos los equipos devueltos en buen estado. Trabajo completado exitosamente..."
              value={notasCerrarTodo}
              onChange={(e) => setNotasCerrarTodo(e.target.value)}
              disabled={procesando}
              maxLength={500}
            />
            <Form.Text>{notasCerrarTodo.length}/500</Form.Text>
          </Form.Group>

          <Alert variant="info" className="mb-0">
            <small>
              💡 <strong>Nota:</strong> Todos los equipos se cerrarán automáticamente, incluso si tienen OTs pendientes.
            </small>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowCerrarTodoModal(false)}
            disabled={procesando}
          >
            Cancelar
          </Button>
          <Button 
            variant="danger" 
            onClick={confirmarCerrarTodoMovimiento} 
            disabled={procesando}
          >
            {procesando ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <>
                <FaLock className="me-2" />
                Cerrar TODO el Movimiento
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>

      {/* Modal Agregar Patrón al grupo */}
      <Modal
        show={showAgregarPatronModal}
        onHide={() => setShowAgregarPatronModal(false)}
        size="xl"
        backdrop="static"
        scrollable
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <i className="bi bi-plus-circle me-2"/>
            Agregar Patrón al Grupo {groupConsecutive}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Filtros */}
          <div className="row g-2 mb-3">
            <div className="col-md-3">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Inventario..."
                value={filtroPatrones.inventario}
                onChange={e => setFiltroPatrones(f => ({ ...f, inventario: e.target.value }))}
              />
            </div>
            <div className="col-md-3">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Marca..."
                value={filtroPatrones.marca}
                onChange={e => setFiltroPatrones(f => ({ ...f, marca: e.target.value }))}
              />
            </div>
            <div className="col-md-3">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Modelo..."
                value={filtroPatrones.modelo}
                onChange={e => setFiltroPatrones(f => ({ ...f, modelo: e.target.value }))}
              />
            </div>
            <div className="col-md-3">
              <select
                className="form-select form-select-sm"
                value={filtroPatrones.disponibilidad || 'disponible'}
                onChange={e => setFiltroPatrones(f => ({ ...f, disponibilidad: e.target.value }))}
              >
                <option value="todos">Todos</option>
                <option value="disponible">Disponibles</option>
                <option value="en-servicio">En Servicio</option>
              </select>
            </div>
          </div>

          {loadingPatrones ? (
            <div className="text-center py-4"><Spinner animation="border" /></div>
          ) : (
            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <table className="table table-sm table-hover">
                <thead className="table-light sticky-top">
                  <tr>
                    <th style={{ width: 40 }}>
                      <input
                        type="checkbox"
                        checked={patronesSeleccionados.length > 0 &&
                          patronesDisponibles
                            .filter(p => {
                              const disp = filtroPatrones.disponibilidad || 'disponible';
                              if (disp === 'disponible' && p.inService) return false;
                              if (disp === 'en-servicio' && !p.inService) return false;
                              if (filtroPatrones.inventario && !p.inventario?.toLowerCase().includes(filtroPatrones.inventario.toLowerCase())) return false;
                              if (filtroPatrones.marca && !p.marca?.toLowerCase().includes(filtroPatrones.marca.toLowerCase())) return false;
                              if (filtroPatrones.modelo && !p.modelo?.toLowerCase().includes(filtroPatrones.modelo.toLowerCase())) return false;
                              return true;
                            })
                            .every(p => patronesSeleccionados.includes(p._id))
                        }
                        onChange={e => {
                          const filtrados = patronesDisponibles.filter(p => {
                            const disp = filtroPatrones.disponibilidad || 'disponible';
                            if (disp === 'disponible' && p.inService) return false;
                            if (disp === 'en-servicio' && !p.inService) return false;
                            if (filtroPatrones.inventario && !p.inventario?.toLowerCase().includes(filtroPatrones.inventario.toLowerCase())) return false;
                            if (filtroPatrones.marca && !p.marca?.toLowerCase().includes(filtroPatrones.marca.toLowerCase())) return false;
                            if (filtroPatrones.modelo && !p.modelo?.toLowerCase().includes(filtroPatrones.modelo.toLowerCase())) return false;
                            return !p.inService;
                          });
                          if (e.target.checked) {
                            setPatronesSeleccionados([...new Set([...patronesSeleccionados, ...filtrados.map(p => p._id)])]);
                          } else {
                            const filtradosIds = filtrados.map(p => p._id);
                            setPatronesSeleccionados(prev => prev.filter(id => !filtradosIds.includes(id)));
                          }
                        }}
                      />
                    </th>
                    <th>Inventario</th>
                    <th>Patrón</th>
                    <th>Marca / Modelo</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {patronesDisponibles
                    .filter(p => {
                      const disp = filtroPatrones.disponibilidad || 'disponible';
                      if (disp === 'disponible' && p.inService) return false;
                      if (disp === 'en-servicio' && !p.inService) return false;
                      if (filtroPatrones.inventario && !p.inventario?.toLowerCase().includes(filtroPatrones.inventario.toLowerCase())) return false;
                      if (filtroPatrones.marca && !p.marca?.toLowerCase().includes(filtroPatrones.marca.toLowerCase())) return false;
                      if (filtroPatrones.modelo && !p.modelo?.toLowerCase().includes(filtroPatrones.modelo.toLowerCase())) return false;
                      return true;
                    })
                    .map(patron => (
                      <tr
                        key={patron._id}
                        style={{
                          cursor: patron.inService ? 'not-allowed' : 'pointer',
                          opacity: patron.inService ? 0.5 : 1,
                          backgroundColor: patronesSeleccionados.includes(patron._id) ? '#cfe2ff' : ''
                        }}
                        onClick={() => {
                          if (patron.inService) return;
                          setPatronesSeleccionados(prev =>
                            prev.includes(patron._id)
                              ? prev.filter(id => id !== patron._id)
                              : [...prev, patron._id]
                          );
                        }}
                      >
                        <td onClick={e => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={patronesSeleccionados.includes(patron._id)}
                            disabled={patron.inService}
                            onChange={() => {
                              if (patron.inService) return;
                              setPatronesSeleccionados(prev =>
                                prev.includes(patron._id)
                                  ? prev.filter(id => id !== patron._id)
                                  : [...prev, patron._id]
                              );
                            }}
                          />
                        </td>
                        <td><strong>{patron.inventario}</strong></td>
                        <td>{patron.item}</td>
                        <td>{patron.marca} {patron.modelo}</td>
                        <td>
                          {patron.inService
                            ? <span className="badge bg-danger">En Servicio</span>
                            : <span className="badge bg-success">Disponible</span>
                          }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          )}

          <div className="mt-3">
            <label className="form-label small fw-bold">Notas (opcional)</label>
            <textarea
              className="form-control form-control-sm"
              rows={2}
              placeholder="Observaciones..."
              value={notasAgregarPatron}
              onChange={e => setNotasAgregarPatron(e.target.value)}
              maxLength={300}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <span className="text-muted me-auto small">{patronesSeleccionados.length} seleccionado(s)</span>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowAgregarPatronModal(false)}
            disabled={procesando}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={confirmarAgregarPatron}
            disabled={procesando || patronesSeleccionados.length === 0}
          >
            {procesando ? <Spinner animation="border" size="sm" /> : `Agregar ${patronesSeleccionados.length > 0 ? `(${patronesSeleccionados.length})` : ''}`}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DetalleMovimiento;
